import classNames from 'classnames';
import { styles } from 'src/layouts/GenericScreenLayout/styles';

const Pagination = ({
  component,
  hasBackground = false
}: {
  component: JSX.Element;
  hasBackground?: boolean;
}) => {
  const { classes } = styles();
  return (
    <div className={classNames(classes.container, { [classes.isBackground]: hasBackground })}>
      {component}
    </div>
  );
};
Pagination.displayName = 'Pagination';

export default Pagination;
